module.exports = __webpack_public_path__ + "assets/d5000bd8a0e07531aa7c34c4adac58a5.png";